import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar, withTheme } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import * as errorHandlerActions from '../../redux/actions/errorHandler';

function Notification({ errorMessage, variant, actions }) {
  const handleClose = () => {
    actions.clearErrorMessage();
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(errorMessage)}
      onClose={handleClose}
      message={errorMessage}
      action={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <React.Fragment>
          <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      }
      TransitionProps={{
        onExited: handleClose,
      }}
    >
      <Alert severity={variant || 'error'} onClose={handleClose}>
        {errorMessage}
      </Alert>
    </Snackbar>
  );
}

Notification.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired,
  variant: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  errorMessage: state.errorHandler.message,
  variant: state.errorHandler.variant,
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(errorHandlerActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(Notification));
